/**
 * Viaticos y Fondos por Rendir API Service
 */
import api from './api';

const API_BASE_URL = (() => {
  const baseURL = api?.defaults?.baseURL || '/api/content';
  return baseURL.replace(/\/content\/?$/i, '/contabilidad');
})();

const viaticosService = {
  getAll: (filters = {}) => api.get(`${API_BASE_URL}/solicitudes-viatico/`, { params: filters }),
  getById: (id) => api.get(`${API_BASE_URL}/solicitudes-viatico/${id}/`),
  create: (data) => api.post(`${API_BASE_URL}/solicitudes-viatico/`, data),
  update: (id, data) => api.patch(`${API_BASE_URL}/solicitudes-viatico/${id}/`, data),
  delete: (id) => api.delete(`${API_BASE_URL}/solicitudes-viatico/${id}/`),
  enviar: (id) => api.post(`${API_BASE_URL}/solicitudes-viatico/${id}/enviar/`),
  aprobar: (id, data = {}) => api.post(`${API_BASE_URL}/solicitudes-viatico/${id}/aprobar/`, data),
  rechazar: (id, data = {}) => api.post(`${API_BASE_URL}/solicitudes-viatico/${id}/rechazar/`, data),
  entregarFondo: (id, data = {}) => api.post(`${API_BASE_URL}/solicitudes-viatico/${id}/entregar_fondo/`, data),
  rendir: (id, data) => api.post(`${API_BASE_URL}/solicitudes-viatico/${id}/rendir/`, data),
  cerrar: (id) => api.post(`${API_BASE_URL}/solicitudes-viatico/${id}/cerrar/`),
};

export default viaticosService;
